import { observer } from 'mobx-react';
import { IValidationGroup } from '../../../../../../../hooks/validation-group/validation-group-hook';
import ApiKeyField from '../fields/api-key-field/api-key-field';
import ApiSecretField from '../fields/api-secret-field/api-secret-field';
import ApiSecretCredentialsStore from '../../../../stores/credentials/shipping/api-secret-credentials-store';

interface IProps {
    credentialsStore: ApiSecretCredentialsStore,
    vGroup: IValidationGroup,
    apiKeyLabel?: string,
    apiKeyNote?: string,
    apiSecretLabel?: string,
    apiSecretNote?: string,
}

const ApiSecretCredentials: React.FC<IProps> = observer(({ 
    credentialsStore, 
    vGroup, 
    apiKeyLabel, 
    apiKeyNote,
    apiSecretLabel,
    apiSecretNote,
}) => {
    return (
        <>
            <ApiKeyField
                credentialsStore={credentialsStore}
                validationGroup={vGroup}
                label={apiKeyLabel}
                note={apiKeyNote}
            />
            <ApiSecretField
                credentialsStore={credentialsStore}
                validationGroup={vGroup}
                label={apiSecretLabel}
                note={apiSecretNote}
            />
        </>
    )
});

export default ApiSecretCredentials;
